module.exports = __webpack_public_path__ + "img/0039.57a62265.gif";